import { getErrorMsg } from "./common";
import { EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_ERROR_MARKER } from "./webSignupExistingMemberError.constants";

export {
  EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_BACKEND_MESSAGE,
  EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_ERROR_MARKER,
} from "./webSignupExistingMemberError.constants";

export const isExistingActiveMemberWebSignupError = (
  error: unknown
): boolean => {
  const { rawCaseErrorMsg, rawErrorMsg } = getErrorMsg(error);
  const combined = `${rawCaseErrorMsg} ${rawErrorMsg}`.toLowerCase();
  return combined.includes(EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_ERROR_MARKER);
};
